import { InventoryImport } from './Imports'
const { RoutesMap, BrandList, AddBrand, UpdateBrand, SubCategoryList, AddSubCategory, UpdateSubCategory, ItemList, AddItem, UpdateItem, MeasureUnitList, AddMeasureUnit, UpdateMeasureUnit, MeasureUnitTypeList, AddMeasureUnitType, UpdateMeasureUnitType, ProductPricingList, UpdateProductPricing, CustomerPricingList, UpdateCustomerPricing, CustomerCategoryPricingList, UpdateCustomerCategoryPricing, ColorList, AddColor, UpdateColor, SegmentList, AddSegment, UpdateSegment, RackList, AddRack, UpdateRack, GenerateDeliveryNote, DeliveryNoteList, PaymentList, AddPayment, InvoiceList, AddInvoice, StockReject } = InventoryImport

const InventoryRoute = () => {
    return [
        {
            path: RoutesMap.BRAND_LIST.path,
            element: <BrandList />
        },
        {
            path: RoutesMap.ADD_BRAND.path,
            element: <AddBrand />
        },
        {
            path: RoutesMap.UPDATE_BRAND.path,
            element: <UpdateBrand />
        },


        {
            path: RoutesMap.SUB_CATEGORY_LIST.path,
            element: <SubCategoryList />
        },
        {
            path: RoutesMap.ADD_SUB_CATEGORY.path,
            element: <AddSubCategory />
        },
        {
            path: RoutesMap.UPDATE_SUB_CATEGORY.path,
            element: <UpdateSubCategory />
        },


        {
            path: RoutesMap.ITEM_LIST.path,
            element: <ItemList />
        },
        {
            path: RoutesMap.ADD_ITEM.path,
            element: <AddItem />
        },
        {
            path: RoutesMap.UPDATE_ITEM.path,
            element: <UpdateItem />
        },


        {
            path: RoutesMap.MEASURE_UNIT_LIST.path,
            element: <MeasureUnitList />
        },
        {
            path: RoutesMap.ADD_MEASURE_UNIT.path,
            element: <AddMeasureUnit />
        },
        {
            path: RoutesMap.UPDATE_MEASURE_UNIT.path,
            element: <UpdateMeasureUnit />
        },


        {
            path: RoutesMap.MEASURE_UNIT_TYPE_LIST.path,
            element: <MeasureUnitTypeList />
        },
        {
            path: RoutesMap.ADD_MEASURE_UNIT_TYPE.path,
            element: <AddMeasureUnitType />
        },
        {
            path: RoutesMap.UPDATE_MEASURE_UNIT_TYPE.path,
            element: <UpdateMeasureUnitType />
        },


        {
            path: RoutesMap.PRODUCT_PRICING_LIST.path,
            element: <ProductPricingList />
        },
        {
            path: RoutesMap.UPDATE_PRODUCT_PRICING.path,
            element: <UpdateProductPricing />
        },


        {
            path: RoutesMap.CUSTOMER_PRICING_LIST.path,
            element: <CustomerPricingList />
        },
        {
            path: RoutesMap.UPDATE_CUSTOMER_PRICING.path,
            element: <UpdateCustomerPricing />
        },


        {
            path: RoutesMap.CUSTOMER_CATEGORY_PRICING_LIST.path,
            element: <CustomerCategoryPricingList />
        },
        {
            path: RoutesMap.UPDATE_CUSTOMER_CATEGORY_PRICING.path,
            element: <UpdateCustomerCategoryPricing />
        },


        {
            path: RoutesMap.COLOR_LIST.path,
            element: <ColorList />
        },
        {
            path: RoutesMap.ADD_COLOR.path,
            element: <AddColor />
        },
        {
            path: RoutesMap.UPDATE_COLOR.path,
            element: <UpdateColor />
        },


        {
            path: RoutesMap.SEGMENT_LIST.path,
            element: <SegmentList />
        },
        {
            path: RoutesMap.ADD_SEGMENT.path,
            element: <AddSegment />
        },
        {
            path: RoutesMap.UPDATE_SEGMENT.path,
            element: <UpdateSegment />
        },


        {
            path: RoutesMap.RACK_LIST.path,
            element: <RackList />
        },
        {
            path: RoutesMap.ADD_RACK.path,
            element: <AddRack />
        },
        {
            path: RoutesMap.UPDATE_RACK.path,
            element: <UpdateRack />
        },


        {
            path: RoutesMap.CREATE_DELIVERY_NOTE.path,
            element: <GenerateDeliveryNote />
        },
        {
            path: RoutesMap.DELIVERY_NOTE_LIST.path,
            element: <DeliveryNoteList />
        },


        {
            path: RoutesMap.PAYMENT_LIST.path,
            element: <PaymentList />
        },
        {
            path: RoutesMap.ADD_PAYMENT.path,
            element: <AddPayment />
        },


        {
            path: RoutesMap.INVOICE_LIST.path,
            element: <InvoiceList />
        },
        {
            path: RoutesMap.ADD_INVOICE.path,
            element: <AddInvoice />
        },
        {
            path: RoutesMap.STOCK_REJECT.path,
            element: <StockReject />
        },
    ]
}

export default InventoryRoute;